export default {
    mpanel: {
        submit: '确定',
        cancel: '取消',
        mpage: {
            total: '条记录',
            page: '页'
        },
        mtable: {
            index: '序号',
            actions: '操作'
        }
    },
    tagsNav: {
        allTags: '所有标签页',
        closeAll: '全部关闭'
    },
    tagsView: {
        refresh: '刷新',
        close: '关闭',
        closeOthers: '关闭其他',
        closeAll: '全部关闭'
    },
    topHeader: {
        lang: 'CN',
        message: '消息',
        service: '服务与支持'
    }
};
